import styled from "styled-components";
import { responsive } from "../../../styles/constants.style";

export const CPEditParticipantMainWrapper = styled.div`
  .header-left {
    margin: 4px 0px 16px;
    ${responsive.SMALL_LAPTOP`
      flex-basis: 100%;
      max-width: 100%;  
    `}
  }
`;
